import $ from "jquery";

class FilterCatgs {
    constructor() {
        const dropdownMobile = document.querySelector('.select-filter-mobile');
        const filters = document.querySelector('.filters');
        const btnclose = document.querySelector(".btn-mobile");
        const dropdown = document.querySelectorAll(".button-group");
        const optionsFilter = document.querySelectorAll('.group-options input');
        const clenFilter = document.querySelector('.clean-filter');

        if (window.location.href.includes('aplicacoes')) {
            document.querySelector('.filter').scrollIntoView();
        }

        optionsFilter.forEach(checkbox => {
            checkbox.addEventListener('click', function () {
                filters.submit();
            });
        });

        clenFilter.addEventListener('click', function () {
            filters[0].reset()
        });

        dropdownMobile.addEventListener('click', function (event) {
            event.preventDefault();
            filters.classList.toggle("active");
        });

        btnclose.addEventListener('click', function (event) {
            event.preventDefault();
            $('.filters').removeClass('active');
        })

        dropdown.forEach(function (element) {
            element.addEventListener('click', function (event) {
                event.preventDefault();
                $(this).siblings('.group-options').toggleClass('active');
                $(this).toggleClass('active');
            })
        });
    }
}

export default FilterCatgs;